import { LineChart } from '@mui/x-charts/LineChart'

type Props = {
  name: string
  quarters: string[]
  target: (number | null)[]
  avg: (number | null)[]
  upper: (number | null)[]
  lower: (number | null)[]
}

export const WhalesChart = ({ name, quarters, target, avg, upper, lower }: Props) => {
  return (
    <LineChart
      xAxis={[
        {
          scaleType: 'point',
          data: quarters,
        },
      ]}
      series={[
        { data: target, label: name },
        { data: avg, label: 'Average bucket', showMark: false, color: 'white' },
        { data: upper, label: '+25%', showMark: false },
        { data: lower, label: '-25%', showMark: false },
      ]}
      height={400}
    />
  )
}
